import type { ChatStatus, Message, SlackMessage } from './types'

const API_BASE = (window as any).__OWNER_CHAT_API__ || 'https://chat.ownerinspections.com.au'

export async function getStatus(): Promise<ChatStatus> {
	const res = await fetch(`${API_BASE}/api/chat/status`)
	if (!res.ok) return { online: false }
	return res.json()
}

export async function sendAiMessage(
	messages: { role: string; content: string }[]
): Promise<{ reply: string; tool_call?: { name: string; result?: any } }> {
	const res = await fetch(`${API_BASE}/api/chat/ai`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ messages }),
	})
	if (!res.ok) throw new Error('AI request failed')
	return res.json()
}

export async function sendToSlack(
	messages: Message[],
	visitorInfo: { name?: string; phone?: string }
): Promise<{ thread_ts: string }> {
	const res = await fetch(`${API_BASE}/api/chat/send`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ messages, visitorInfo }),
	})
	if (!res.ok) throw new Error('Slack send failed')
	return res.json()
}

export async function getSlackMessages(threadTs: string): Promise<SlackMessage[]> {
	const res = await fetch(`${API_BASE}/api/chat/messages?thread=${threadTs}`)
	if (!res.ok) return []
	return res.json()
}
